import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import settings from "../../settings";
import router from "@/router";

Vue.use(Vuex);

let default_event_task_data = {
    id: null,
    notes: null,
    time: null,
    deadline: null,
    status: null,
    name: null,
    done_date: null,
    event_id: null,
    date: null
};

export default {
    namespaced: true,
    state: {
        task_errors: [],
        months: [],
        events: [],
        task_events: [],
        task_event_save_btn_disabled: true,
        task_event_save_btn_loading: false,
        task: JSON.parse(JSON.stringify(default_event_task_data))
    },
    mutations: {
        set_task_event_btn_mode(state, val) {
            state.task_event_save_btn_disabled = !val;
        },
        set_btn_loading(state, boolean) {
            state.task_event_save_btn_loading = boolean;
        },
        update_event_task_field(state, { prop_name, prop_value }) {
            //Vue.set(state.event_task, prop_name, prop_value)
            state.task[prop_name] = prop_value;
            if (state.task_errors) {
                state.task_errors = state.task_errors.filter(item => item !== prop_name);
            }
        },
        set_events(state, events) {
            let events_list = [];
            if (events && events.length > 0) {
                events.forEach(event => {
                    //if (!event.original_event_id) {
                    let item = {
                        value: event.event_id,
                        label: event.name
                    };
                    events_list.push(item);
                    //}
                });
            }
            state.events = events_list;
        },
        set_task_event(state, event_task) {
            state.task = event_task;
        },
        clear_tasks(state) {
            state.task_events = [];
        },
        set_task_events(state, data_arr) {
            let page = data_arr.page;
            if (data_arr.task_events && data_arr.task_events.length > 0) {
                data_arr.task_events.forEach(t => {
                    let exists = state.task_events.find(x => x.id === t.id);
                    if (!exists) {
                        if (page && page > 0) {
                            state.task_events.unshift(t);
                        } else {
                            state.task_events.push(t);
                        }
                    }
                });
            }
            if (state.task_events) {
                var result = state.task_events.find(obj => {
                    return obj.status === "in_progress" && obj.time;
                });
                if (!result) {
                    result = state.task_events.find(obj => {
                        return obj.status === "in_progress";
                    });
                }
                if (result) {
                    let index = state.task_events.findIndex(_ev => _ev.id == result.id);
                    state.task_events[index].is_current = true;
                }
            }
        },
        set_task_errors(state, errors) {
            state.task_errors = errors;
        },
        set_task(state, event_task) {
            state.event_task = event_task;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        clear_task_event(state) {
            state.event_task = JSON.parse(JSON.stringify(default_event_task_data));
        }
    },
    actions: {
        async save_event_task({ commit }, payload) {
            commit("set_btn_loading", true);

            let errors = [];
            let data = payload;
            let fields_to_validate = ["name"];
            fields_to_validate.forEach(f => {
                if (!payload[f]) {
                    errors.push(f);
                }
                if (payload.time) {
                    if (!payload.date) {
                        errors.push("date");
                    }
                }
            });
            commit("set_task_errors", errors);
            if (errors.length === 0) {
                try {
                    let response = await axios.post(settings.api_url + "/event-task/", data);
                    if (response && response.data) {
                        commit("set_btn_loading", false);
                        if (response.data.success === 1) {
                            commit("set_task", response.data.event_task);
                            router.push({
                                path: "/tasks/"
                            });
                        } else {
                            router.push({
                                path: "/error/"
                            });
                        }
                    }
                } catch (error) {
                    commit("set_btn_loading", false);
                    if (error.data) {
                        router.push({
                            path: "/error/"
                        });
                    } else {
                        router.push({
                            path: "/error/connection-lost"
                        });
                    }
                }
            }
        },
        async get_task_events({ commit }, page = null) {
            let data = {};
            if (page) {
                data = {
                    current_page: page
                };
            }
            try {
                let response = await axios.get(settings.api_url + "/task-events/", {
                    params: data
                });
                if (response && response.data) {
                    let events_data = response.data;
                    commit("set_task_events", {
                        task_events: events_data,
                        page: page
                    });
                    return true;
                }
            } catch (error) {
                if (error.status === 401) {
                    router.push({ path: "/login" });
                }
                return false;
            }
        },
        async get_user_events({ commit }) {
            let args = {
                action: "get_user_events"
            };
            try {
                let response = await axios.post(settings.api_url + "/user/", args);
                if (response) {
                    let rd = response.data;
                    if (rd.success) {
                        commit("set_events", rd.events);
                    }
                }
            } catch (error) {
                console.log(error);
                console.log(error.data);
            }
            return true;
        }
    }
};
